var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pub-container home"
  }, [_c("FormBox", {
    attrs: {
      title: "康复绿通"
    },
    on: {
      inspect: _vm.inspectBtn
    }
  }, [_c("el-form", {
    ref: "form",
    staticStyle: {
      width: "100%",
      "padding-right": "20px"
    },
    attrs: {
      model: _vm.data,
      "label-width": "100px",
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "年龄",
      prop: "age"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入年龄"
    },
    model: {
      value: _vm.data.age,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "age", $$v);
      },
      expression: "data.age"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "地区",
      prop: "region"
    }
  }, [_c("el-cascader", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      options: _vm.provinces,
      "show-all-levels": false,
      props: {
        value: "name",
        label: "name",
        children: "cities"
      },
      placeholder: "请选择地区"
    },
    on: {
      change: _vm.change
    },
    model: {
      value: _vm.data.region,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "region", $$v);
      },
      expression: "data.region"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "医院",
      prop: "hospital"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择医院"
    },
    model: {
      value: _vm.data.hospital,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "hospital", $$v);
      },
      expression: "data.hospital"
    }
  }, _vm._l(_vm.hospitalList, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "预约时间",
      prop: "appointmentTime"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请选择预约时间",
      readonly: ""
    },
    nativeOn: {
      click: function click($event) {
        _vm.showPicker = true;
      }
    },
    model: {
      value: _vm.data.appointmentTime,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "appointmentTime", $$v);
      },
      expression: "data.appointmentTime"
    }
  })], 1), _c("van-popup", {
    attrs: {
      position: "bottom"
    },
    model: {
      value: _vm.showPicker,
      callback: function callback($$v) {
        _vm.showPicker = $$v;
      },
      expression: "showPicker"
    }
  }, [_c("van-datetime-picker", {
    attrs: {
      type: "datetime",
      "min-date": _vm.minDate
    },
    on: {
      confirm: _vm.onConfirm,
      cancel: function cancel($event) {
        _vm.showPicker = false;
      }
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "上传病例",
      prop: "uploader"
    }
  }, [_c("van-uploader", {
    attrs: {
      "after-read": _vm.afterReadAvatar,
      "max-count": 1,
      disabled: _vm.isIpt
    },
    model: {
      value: _vm.data.uploader,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "uploader", $$v);
      },
      expression: "data.uploader"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      margin: "16px",
      width: "100%",
      padding: "0 20px"
    }
  }, [_c("el-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary",
      round: "",
      disabled: _vm.isIpt
    },
    on: {
      click: function click($event) {
        return _vm.onSubmit("form");
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };